
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adminUser",
      function () {
        return require("private-next-pages/adminUser/index.tsx");
      }
    ]);
  